import { initializeApp } from 'firebase/app';
import {
	getAuth,
	RecaptchaVerifier,
	signInWithPhoneNumber,
	GoogleAuthProvider,
	signInWithPopup,
} from 'firebase/auth';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';

let auth = null;
let confirmationResult = null;
let iti = null;

function showNotice( el, message, isSuccess = false ) {
	if ( ! el ) return;
	el.textContent = message;
	el.hidden = false;
	el.classList.toggle( 'is-success', isSuccess );
}

function setStep( card, step ) {
	card.querySelectorAll( '[data-step]' ).forEach( ( el ) => {
		el.hidden = el.dataset.step !== step;
	} );
}

async function postToken( idToken, notice ) {
	const res = await fetch( window.cannaliciousLogin.restUrl + 'auth/verify', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-WP-Nonce': window.cannaliciousLogin.nonce,
		},
		body: JSON.stringify( { id_token: idToken } ),
	} );
	const data = await res.json();

	if ( data.success ) {
		showNotice( notice, 'Signed in! Redirecting…', true );
		window.location.href = data.redirect || window.cannaliciousLogin.redirectUrl;
	} else {
		showNotice( notice, data.message || 'Something went wrong. Please try again.' );
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	const card = document.querySelector( '.login-card' );
	if ( ! card || ! window.cannaliciousLogin ) {
		return;
	}

	const notice = card.querySelector( '[data-login-notice]' );
	const phoneInput = document.getElementById( 'login-phone' );
	const sendCodeBtn = card.querySelector( '[data-send-code]' );
	const verifyCodeBtn = card.querySelector( '[data-verify-code]' );
	const backBtn = card.querySelector( '[data-back-to-phone]' );
	const googleBtn = card.querySelector( '[data-google-signin]' );

	if ( phoneInput ) {
		iti = intlTelInput( phoneInput, {
			initialCountry: 'us',
			separateDialCode: true,
			utilsScript: undefined,
		} );
	}

	if ( ! window.cannaliciousLogin.isConfigured ) {
		showNotice( notice, 'Sign-in is not configured yet. Please check back soon.' );
		sendCodeBtn?.setAttribute( 'disabled', 'disabled' );
		googleBtn?.setAttribute( 'disabled', 'disabled' );
		return;
	}

	const app = initializeApp( window.cannaliciousLogin.firebaseConfig );
	auth = getAuth( app );

	sendCodeBtn?.addEventListener( 'click', async () => {
		const phoneNumber = iti ? iti.getNumber() : phoneInput?.value;
		if ( ! phoneNumber ) {
			showNotice( notice, 'Please enter your mobile number.' );
			return;
		}

		sendCodeBtn.disabled = true;

		try {
			const verifier = new RecaptchaVerifier( auth, 'recaptcha-container', { size: 'invisible' } );
			confirmationResult = await signInWithPhoneNumber( auth, phoneNumber, verifier );
			setStep( card, 'code' );
			notice.hidden = true;
		} catch ( err ) {
			showNotice( notice, err.message || 'Could not send a verification code. Please try again.' );
		} finally {
			sendCodeBtn.disabled = false;
		}
	} );

	verifyCodeBtn?.addEventListener( 'click', async () => {
		const code = document.getElementById( 'login-code' )?.value?.trim();
		if ( ! code || ! confirmationResult ) {
			showNotice( notice, 'Please enter the 6-digit code.' );
			return;
		}

		verifyCodeBtn.disabled = true;

		try {
			const result = await confirmationResult.confirm( code );
			const idToken = await result.user.getIdToken();
			await postToken( idToken, notice );
		} catch ( err ) {
			showNotice( notice, 'That code did not match. Please try again.' );
		} finally {
			verifyCodeBtn.disabled = false;
		}
	} );

	backBtn?.addEventListener( 'click', () => {
		setStep( card, 'phone' );
		notice.hidden = true;
	} );

	googleBtn?.addEventListener( 'click', async () => {
		googleBtn.disabled = true;
		try {
			const provider = new GoogleAuthProvider();
			const result = await signInWithPopup( auth, provider );
			const idToken = await result.user.getIdToken();
			await postToken( idToken, notice );
		} catch ( err ) {
			showNotice( notice, 'Google sign-in was not completed. Please try again.' );
		} finally {
			googleBtn.disabled = false;
		}
	} );
} );
